<template>
  <div class="inquiry">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>お問い合わせ・ご要望</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">お問い合わせ</h1> -->
    </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <ValidationProvider
            rules="required|max:500"
            immediate
            v-slot="ProviderProps"
          >
            <textarea
              v-model="comment"
              placeholder="お問い合わせ内容や機能追加のご要望を記述してください"
            ></textarea>
            <div class="validation-error">
              {{ ProviderProps.errors[0] }}
            </div>
          </ValidationProvider>
        </div>
      </div>
      <div id="button-area">
        <div class="left-box" />
        <div class="center-box">
          <span
            class="btn btn-submit"
            :class="{
              active: true,
              disable: ObserverProps.invalid,
            }"
            @click="onSend"
            >送信</span
          >
        </div>
        <div class="right-box" />
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      comment: null,
      user: null,
    };
  },

  async mounted() {
    this.$emit("hideMap");
  },

  methods: {
    ...mapActions(["sendInquiry"]),

    onSend: function() {
      this.loading(async () => {
        await this.sendInquiry({ comment: this.comment });
        this.$router.push({ name: "dashboard" });
      });
    },
    onCancel: function() {
      console.log("cancel");
    },
  },
};
</script>
<style lang="scss">
.inquiry {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 60%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  textarea {
    font-size: 16px;
    width: 100%;
    min-height: 300px;
    white-space: pre-wrap;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: solid 1px var(--purple);
    padding: 10px;
    border-radius: 10px 10px 0 10px;
    font-family: inherit;
  }

  textarea:focus {
    background: var(--purple-tertiary);
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 0px auto 40px;

    .right-box {
      right: 0;
      bottom: 0;
      width: 25%;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 50%);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 25%;
      .mobile & {
        width: unset;
      }
    }
    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
      width: 130px;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_email.svg") no-repeat center center;
  }
}
</style>
